import { Visibility } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import dayjs from "dayjs";

export const dateFormatter = (date) => {
  return dayjs(new Date(Number(date))).format("DD/MM/YYYY HH:mm:ss");
};

export const leadInfoColumn = [
  {
    field: "lead_id",
    headerName: "Lead ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "lead_status_id",
    headerName: "Lead Status ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "lead_category_id",
    headerName: "Lead Category ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "branch_code",
    headerName: "Branch Code",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
    valueGetter: (params) =>
      params.row.createdDate !== null
        ? dateFormatter(params.row.createdDate)
        : "",
  },
  {
    field: "lastModifiedDate",
    headerName: "Last Modified Date",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
    valueGetter: (params) =>
      params.row.lastModifiedDate !== null
        ? dateFormatter(params.row.lastModifiedDate)
        : "",
  },
  {
    field: "icon",
    headerName: "",
    headerAlign: "center",
    align: "center",
    flex: 50,
    type: "string",
    editable: false,
    renderCell: (params) => {
      return (
        <Box
          sx={{
            justifyContent: "center",
            display: "flex",
            flex: 25,
          }}
        >
          <Tooltip title="View Detail">
            <IconButton
              onClick={(e) => {
                viewLeadDetail(params);
              }}
            >
              <Visibility sx={{ color: "black" }} />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  },
];

const viewLeadDetail = (param) => {
  window.open(
    `/stlap/home/losData/leadInfoList/${param.row.lead_id}/${param.row.branch_code}`,
    "_blank"
  );
};

export const leadInfoListData = async (values) => {
  let dataList = [];
  values.forEach((v) => {
    dataList.push({
      id: v["lead_id"] + v["branch_code"],
      lead_id: v["lead_id"],
      lead_status_id: v["lead_status_id"],
      lead_category_id: v["lead_category_id"],
      branch_code: v["branch_code"],
      createdDate: v["createdDate"],
      lastModifiedDate: v["lastModifiedDate"],
    });
  });
  return dataList;
};
